import {GetterTree} from 'vuex'
import {WidgetState} from "@/apps/MyStudyChoiceCreatedWidget/models/store-viewmodel";
import {Config, Labels} from "../models/config-viewmodel";

export default <GetterTree<WidgetState, WidgetState>>{
    config(state): Config {
        return state.config
    },
    labels(state): Labels {
        return state.config.labels
    }
}
